import React, { useState } from 'react';
import './RegisterProvider.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Alert from '../../components/Alert/Alert';
import emailjs from '@emailjs/browser';

export default function RegisterProvider() {
    const [formData, setFormData] = useState({
        nombre: '',
        apellido: '',
        telefono: '',
        ciudad: '',
        departamento: '',
        empresa: '',
        antiguedad: '',
        productos: '',
        tipo: '', // fabricante o distribuidor
    });

    const [alert, setAlert] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await emailjs.send(
                "service_s0c2e5w",
                "template_simple_minymol",
                formData,
                "yHE_T7SENJdKd_roU"
            );

            setAlert({ type: 'success', message: '✅ Solicitud enviada correctamente.' });
            setFormData({
                nombre: '',
                apellido: '',
                telefono: '',
                ciudad: '',
                departamento: '',
                empresa: '',
                antiguedad: '',
                productos: '',
                tipo: '',
            });
        } catch (error) {
            console.error("❌ Error al enviar:", error);
            setAlert({ type: 'error', message: 'Error al enviar la solicitud.' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Header minimal={true} />
            <form className="form-proveedor" onSubmit={handleSubmit}>
                <h2 className="form-title">Formulario de Registro para Proveedores</h2>

                <input name="nombre" required placeholder="Nombre" onChange={handleChange} value={formData.nombre} />
                <input name="apellido" required placeholder="Apellido" onChange={handleChange} value={formData.apellido} />
                <input name="telefono" required placeholder="Teléfono o WhatsApp" onChange={handleChange} value={formData.telefono} />
                <input name="ciudad" required placeholder="Ciudad" onChange={handleChange} value={formData.ciudad} />
                <input name="departamento" required placeholder="Departamento" onChange={handleChange} value={formData.departamento} />
                <input name="empresa" required placeholder="Nombre de la empresa" onChange={handleChange} value={formData.empresa} />
                <input name="antiguedad" required placeholder="Años de antigüedad" onChange={handleChange} value={formData.antiguedad} />
                <div className="radio-group">
                    <label>
                        <input type="radio" name="tipo" value="Fabricante" onChange={handleChange} checked={formData.tipo === 'Fabricante'} />
                        Fabricante
                    </label>
                    <label>
                        <input type="radio" name="tipo" value="Distribuidor" onChange={handleChange} checked={formData.tipo === 'Distribuidor'} />
                        Distribuidor
                    </label>
                </div>
                
                <textarea name="productos" required placeholder="Productos que distribuye" onChange={handleChange} value={formData.productos}></textarea>

                <button type="submit" className="submit-btn" disabled={loading}>
                    {loading ? 'Enviando...' : 'Enviar solicitud'}
                </button>
            </form>

            {alert && (
                <Alert type={alert.type} message={alert.message} onClose={() => setAlert(null)} />
            )}

            <Footer />
        </>
    );
}
